














import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component
export default class LayoutSidebarLinkItemComponent extends Vue {
    @Prop()
    route:object
    @Prop()
    text: string
    @Prop()
    iconUrl:string
}
